(function () {
  var toast = document.getElementById('toast');
  var tTimer;
  function showToast(html) {
    if (!toast) return;
    toast.innerHTML = html; toast.classList.add('show');
    clearTimeout(tTimer); tTimer = setTimeout(function () { toast.classList.remove('show'); }, 3600);
  }
  window.kapToast = showToast;

  // Copy support email
  var copyBtn = document.getElementById('copyEmail');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var el = document.getElementById('supportEmail');
      var addr = el ? el.textContent.trim() : '';
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(addr).then(function () {
          copyBtn.textContent = 'Copied'; setTimeout(function () { copyBtn.textContent = 'Copy'; }, 1600);
        }).catch(function () { showToast('Press Cmd/Ctrl + C to copy'); });
      } else { showToast('Press Cmd/Ctrl + C to copy'); }
    });
  }

  // Product form: add to cart via AJAX so the page doesn't bounce, then confirm.
  var pf = document.getElementById('ProductForm');
  if (pf) {
    pf.addEventListener('submit', function (e) {
      var submitter = e.submitter || document.activeElement;
      if (!submitter || submitter.name !== 'add') return;
      e.preventDefault();
      var btn = submitter; var orig = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(pf) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function (item) {
          showToast('<b>' + (item.product_title || 'Added') + '</b> is in your cart. <a href="/cart" style="text-decoration:underline">View cart →</a>');
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          var c = document.querySelector('.cart-count');
          var link = document.querySelector('.cart-link');
          if (cart && link) {
            if (!c) { c = document.createElement('span'); c.className = 'cart-count'; link.appendChild(document.createTextNode(' ')); link.appendChild(c); }
            c.textContent = cart.item_count;
          }
        })
        .catch(function () { showToast('Couldn’t add that. Try again.'); })
        .finally(function () { btn.disabled = false; btn.textContent = orig; });
    });
  }

  // Mark the current nav link active
  var path = location.pathname.replace(/\/$/, '');
  document.querySelectorAll('.nav-links a').forEach(function (a) {
    var href = (a.getAttribute('href') || '').replace(/\/$/, '');
    if (href && href === path) a.classList.add('active');
  });
})();
